"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = exports.FormMessage = exports.FormMessageSection = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const MESSAGE_TYPE_CLASSNAME = {
    error: 'border-red-400 bg-red-100 text-red-700',
    success: 'border-green-400 bg-green-100 text-green-700',
};
function FormMessageSection({ message, type }) {
    const typeClass = MESSAGE_TYPE_CLASSNAME[type];
    return (react_1.default.createElement("div", { className: `${typeClass} border mb-5 px-4 py-3 rounded relative`, role: "alert" },
        react_1.default.createElement(FormMessage, { message: message })));
}
exports.FormMessageSection = FormMessageSection;
function FormMessage({ message }) {
    return react_1.default.createElement("span", { className: "block sm:inline" }, message);
}
exports.FormMessage = FormMessage;
function Form(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement("form", Object.assign({ className: (0, classnames_1.default)('', className) }, props), children));
}
exports.Form = Form;
